import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
} from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import * as XLSX from "xlsx";

import promotionApi from "../../../apis/Promotion.api";
import pushApi from "../../../apis/Push.api";
import salesManageApi from "../../../apis/SalesManage.api";
import {
  setLoading,
  setSearchText,
  setSelectOrder,
} from "../../../redux/store/common/commonDuck";
import status from "../../../utils/status";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import OrderDetailComponent from "./OrderDetailComponent";

const SalesManageSearchComponent = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const searchText = useSelector((state) => state.common.searchText);
  const setIsSearchText = (value) => dispatch(setSearchText(value));
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));
  const setSelectOrderList = (value) => dispatch(setSelectOrder(value));

  const [dateType, setDateType] = useState("1week");
  const [searchOptions, setSearchOptions] = useState({
    searchType: "payment_created_at",
    searchStatus: "total",
    searchOrderId: "",
    searchProductName: "",
    funnel: 0,
    name: "",
    phone: "",
    startDate: moment().subtract(7, "days").startOf("day"),
    endDate: moment().endOf("day"),
  });
  const [orderType, setOrderType] = useState("payment_created_at");
  const [orderBy, setOrderBy] = useState("desc");
  const [selectedRowKey, setSelectedRowKey] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [totalSize, setTotalSize] = useState(0);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalOrderList, setTotalOrderList] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [orderDetail, setOrderDetail] = useState({});
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [isDepositCancelModalOpen, setIsDepositCancelModalOpen] =
    useState(false);
  const [readyCancelShow, setReadyCancelShow] = useState(false);
  const [editCancelReason, setEditCancelReason] = useState({
    cancel_reason: null,
    refund_bank: null,
  });
  const [error, setError] = useState("");

  const [mobileColumn, setMobileColumn] = useState(false);

  const [cancelButtonShow, setCancelButtonShow] = useState(true);
  /**
   * 모바일 처리 mobile -> true
   */
  const [mediaResult, setMediaResult] = useState(null);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const matchQueryList = window.matchMedia("all and (max-width: 768px)");
      setMediaResult(matchQueryList.matches);
      if (!matchQueryList.matches) {
        setMobileColumn(false);
      }

      const media = function handleChange(e) {
        setMediaResult(e.matches);
        if (!e.matches) {
          setMobileColumn(false);
        }
      };

      matchQueryList.addEventListener("change", media);
    }
  }, []);

  const searchDateItems = [
    { searchText: "결제일", searchType: "payment_created_at" },
    // {searchText: '주문일시', searchType: 'order_created_at'}
  ];
  const dateTypeItems = [
    { label: "오늘", value: "today" },
    { label: "1주일", value: "1week" },
    { label: "1개월", value: "1month" },
    { label: "3개월", value: "3month" },
    { label: "6개월", value: "6month" },
  ];
  const orderStatusItems = [
    { label: "전체", value: "total" },
    { label: "입금대기", value: "ready" },
    { label: "입금완료", value: "paid" },
    // {label: '결제실패', value: 'failed'},
    { label: "결제취소", value: "cancelled" },
    { label: "배송준비중", value: "delivery_ready" },
    { label: "배송중", value: "delivery_shipping" },
    { label: "배송완료", value: "delivery_complete" },
    { label: "구매확정", value: "complete" },
    { label: "취소요청", value: "cancel_request" },
    { label: "취소완료", value: "cancel_complete" },
    { label: "반품요청", value: "return_request" },
    { label: "반품승인", value: "return_receive" },
    { label: "반품거부/철회", value: "return_refusal" },
    { label: "반품수거완료", value: "return_collection_complete" },
    { label: "반품수거취소", value: "return_collection_fail" },
    { label: "반품배송중", value: "return_delivery" },
    { label: "반품배송완료", value: "return_delivery_complete" },
    { label: "반품완료", value: "return_complete" },
    { label: "교환요청", value: "exchange_request" },
    { label: "교환완료", value: "exchange_complete" },
  ];
  const funnelStatusItems = [
    { label: "전체", value: 0 },
    { label: "검색", value: 1 },
    { label: "전화주문", value: 4 },
    { label: "인플루언서", value: 2 },
    { label: "셀러", value: 5 },
    { label: "공동구매", value: 3 },
  ];
  const orderPair = {
    payment_created_at: "결제일순",
    order_id: "주문번호순",
    // created_at: '주문일시순'
  };
  const cancelReasonItems = [
    { label: "미입금", value: "미입금" },
    { label: "상품품절", value: "상품품절" },
    { label: "배송지연", value: "배송지연" },
    { label: "서비스 불만족", value: "서비스 불만족" },
    { label: "구매의사취소", value: "구매의사취소" },
    { label: "색상 및 사이즈 변경", value: "색상 및 사이즈 변경" },
    { label: "다른 상품 잘못 주문", value: "다른 상품 잘못 주문" },
    { label: "상품정보 상이", value: "상품정보 상이" },
  ];
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onSelect: (record, selected) => {
      let editKeyList = [];
      let editRowList = [];
      if (selected) {
        const filterList = totalOrderList.filter(
          (order) => order.order_id === record.order_id,
        );
        const filterKeyList = filterList.map((row) => row.order_detail_id);
        editRowList = [...selectedRow, ...filterList];
        editKeyList = [...selectedRowKey, ...filterKeyList];
      } else {
        editRowList = selectedRow.filter(
          (row) => row.order_id !== record.order_id,
        );
        editKeyList = editRowList.map((row) => row.order_detail_id);
      }
      setSelectedRowKey(editKeyList);
      setSelectedRow(editRowList);
    },
  };
  const columns = [
    {
      title: "주문번호",
      width: 80,
      dataIndex: "order_id",
      key: "order_id",
      fixed: mediaResult ? "" : "left",
      ellipsis: true,
      align: "right",
      // sorter: (a, b) => {},
      render: (value, record) => {
        return (
          <span
            className="recommend-inquiry-list-title"
            onClick={() => {
              setOrderDetail(record);
              setIsOrderModalOpen(true);
            }}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "상품주문번호",
      width: 90,
      dataIndex: "order_detail_id",
      key: "order_detail_id",
      fixed: mediaResult ? "" : "left",
      ellipsis: true,
      align: "right",
      // // sorter: (a, b) => {},
      // render: (value, record) => {
      //     return <span
      //         className="recommend-inquiry-list-title"
      //         onClick={() => {
      //             setOrderDetail(record)
      //             setIsOrderModalOpen(true)
      //         }}
      //     >{value}</span>
      // }
    },
    {
      title: "주문일시",
      width: 160,
      dataIndex: "created_at",
      key: "created_at",
      ellipsis: true,
      // // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "결제일",
      width: 160,
      dataIndex: "payment_created_at",
      key: "payment_created_at",
      ellipsis: true,
      // // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "상품번호",
      // width: 200,
      dataIndex: "product_id",
      key: "product_id",
      ellipsis: true,
      align: "right",
      // render: (value, record) => {
      //     console.log("recc", record)
      //     return <span
      //         className="recommend-inquiry-list-title"
      //         onClick={() => window.open(`https://www.dangyoung.com/products/${value}`)}
      //         >{value}</span>
      // }
    },
    {
      title: "상품명",
      // width: 200,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
    },
    {
      title: "옵션명",
      // width: 200,
      dataIndex: "option_title",
      key: "option_title",
      ellipsis: true,
    },
    {
      title: "수량",
      // width: 90,
      dataIndex: "quantity",
      key: "quantity",
      ellipsis: true,
      align: "right",
    },
    {
      title: "상품별 총 주문금액",
      // width: 150,
      dataIndex: "total_price",
      key: "total_price",
      ellipsis: true,
      align: "right",
      render: (value) => {
        return value.toLocaleString();
      },
    },
    {
      title: "주문상태",
      width: 90,
      dataIndex: "order_detail_status",
      key: "order_detail_status",
      ellipsis: true,
      render: (value, record) => {
        if (
          record.hasOwnProperty("is_deposit") &&
          record.is_deposit &&
          value === "ready"
        ) {
          return "무통장 입금대기";
        } else {
          return status.orderStatusChange(value);
        }
      },
    },
    {
      title: `정산 금액`,
      // width: 200,
      dataIndex: "",
      key: "",
      ellipsis: true,
      align: "right",
      render: (value, record) => {
        if (
          record.order_detail_status !== "ready" &&
          record.order_detail_status !== "cancel_request" &&
          record.order_detail_status !== "cancel_complete" &&
          record.order_detail_status !== "return_request" &&
          record.order_detail_status !== "return_receive" &&
          record.order_detail_status !== "return_collection_complete" &&
          record.order_detail_status !== "return_delivery" &&
          record.order_detail_status !== "return_delivery_complete" &&
          record.order_detail_status !== "return_complete"
        ) {
          let returnPrice = record.total_price;
          // 공동구매
          if (record.is_cooperate) {
            returnPrice =
              returnPrice -
              Math.floor(
                record.total_price * ((record.cooperate_fee_rate * 1.1) / 100),
              );
            // 공동구매 시 - 당영 관리 수수료 11% 추가 제외
            if (record.dy_commission_include) {
              returnPrice = returnPrice - Math.floor(record.total_price * 0.11);
            }
          }
          // 일반구매
          else {
            if (record.is_influencer) {
              returnPrice =
                returnPrice -
                Math.floor(
                  record.total_price * (record.influencer_fee_rate / 100),
                );
            }
            returnPrice = returnPrice - Math.floor(record.total_price * 0.11);
          }
          return returnPrice.toLocaleString();
        } else {
          return 0;
        }
      },
    },
    {
      title: `당영 관리 수수료\n(VAT 포함)`,
      // width: 200,
      dataIndex: "brand_fee_rate",
      key: "brand_fee_rate",
      ellipsis: true,
      align: "right",
      render: (value, record) => {
        if (
          record.order_detail_status !== "ready" &&
          record.order_detail_status !== "cancel_request" &&
          record.order_detail_status !== "return_request" &&
          record.order_detail_status !== "return_receive" &&
          record.order_detail_status !== "return_collection" &&
          record.order_detail_status !== "return_collection_complete" &&
          record.order_detail_status !== "cancel_complete" &&
          record.order_detail_status !== "return_complete"
        ) {
          // 일반 구매
          if (!record.is_cooperate) {
            return "-" + Math.floor(record.total_price * 0.11).toLocaleString();
          }
          // 공동구매
          else {
            // 공동구매 시 - 당영 관리 수수료 11%
            if (record.dy_commission_include) {
              return (
                "-" + Math.floor(record.total_price * 0.11).toLocaleString()
              );
            } else {
              return 0;
            }
          }
        } else {
          return 0;
        }
      },
    },
    {
      title: `매출 연동 수수료\n(VAT 포함)`,
      // width: 200,
      dataIndex: "",
      key: "",
      ellipsis: true,
      align: "right",
      render: (value, record) => {
        if (
          record.order_detail_status !== "ready" &&
          record.order_detail_status !== "cancel_request" &&
          record.order_detail_status !== "cancel_complete" &&
          record.order_detail_status !== "return_request" &&
          record.order_detail_status !== "return_receive" &&
          record.order_detail_status !== "return_collection_complete" &&
          record.order_detail_status !== "return_delivery" &&
          record.order_detail_status !== "return_delivery_complete" &&
          record.order_detail_status !== "return_complete"
        ) {
          if (value.query) {
            if (record.is_cooperate) {
              if (record.order_detail_id === 24514) {
                console.log(
                  record.total_price *
                    ((record.cooperate_fee_rate * 1.1) / 100),
                );
              }
              return record.total_price *
                ((record.cooperate_fee_rate * 1.1) / 100) >
                0
                ? "-" +
                    Math.floor(
                      record.total_price *
                        ((record.cooperate_fee_rate * 1.1) / 100),
                    ).toLocaleString()
                : 0;
            } else {
              return record.total_price *
                ((record.commission_rate * 1.1) / 100) >
                0
                ? "-" +
                    Math.floor(
                      record.total_price *
                        ((record.commission_rate * 1.1) / 100),
                    ).toLocaleString()
                : 0;
            }
          } else {
            return 0;
          }
          //  if (record.is_influencer) {
          //     return "-" + Math.floor(record.total_price * (record.influencer_fee_rate / 100)).toLocaleString()
          // } else {
          //     return 0
          // }
        }
      },
    },
    {
      title: "웹/앱 유입",
      width: 90,
      align: "center",
      dataIndex: "memo",
      key: "memo",
      ellipsis: true,
      render: (value, record) => {
        // 공동구매 아닌 인플루언서 결제 중 -> 웹/앱 구분
        if (record.query) {
          if (!record.is_cooperate) {
            if (
              value &&
              value?.includes("app-true") &&
              !value.includes("web-true")
            ) {
              return "App";
            } else {
              return "Web";
            }
          }
        }
      },
    },
    {
      title: "매출연동수수료 유입경로",
      // width: 200,
      dataIndex: "",
      key: "",
      ellipsis: true,
      align: "center",
      render: (value, record) => {
        let path = "";
        if (value.query) {
          if (record.is_cooperate) {
            path = "공동구매";
          } else {
            if (record?.is_manual) {
              path = "전화주문-";
            }
            if (
              record?.influencer_role === "super_admin" ||
              record?.influencer_role === "level_1"
            ) {
              path += "인플루언서";
            } else {
              path += "셀러";
            }
          }
        } else if (record?.is_manual) {
          path = "전화주문";
        } else {
          path = "검색";
        }
        return path;
      },
    },
    {
      title: "해당 링크",
      // width: 150,
      dataIndex: "query",
      key: "query",
      ellipsis: true,
      render: (value, record) => {
        if (record.influencer_name) {
          return record.influencer_name;
        } else {
          return value;
        }
      },
    },
    {
      title: "클레임상태",
      width: 150,
      dataIndex: "",
      key: "",
    },
    {
      title: "구매자명",
      width: 90,
      dataIndex: "created_by_name",
      key: "created_by_name",
      ellipsis: true,
    },
    {
      title: "수취인명",
      width: 90,
      dataIndex: "name",
      key: "name",
      ellipsis: true,
    },
    {
      title: "연락처",
      // width: 90,
      dataIndex: "phone",
      key: "phone",
      ellipsis: true,
    },
    {
      title: "주소",
      // width: 90,
      dataIndex: "address",
      key: "address",
      ellipsis: true,
    },
    {
      title: "상세주소",
      // width: 90,
      dataIndex: "address_detail",
      key: "address_detail",
      ellipsis: true,
    },
  ];

  const columnsChange = [
    {
      title: "수취인명",
      width: 90,
      dataIndex: "name",
      key: "name",
      ellipsis: true,
    },
    {
      title: "상품별 총 주문금액",
      // width: 150,
      width: 90,
      dataIndex: "total_price",
      key: "total_price",
      ellipsis: true,
      render: (value) => {
        return value.toLocaleString();
      },
    },
    {
      title: "주문상태",
      width: 90,
      dataIndex: "order_detail_status",
      key: "order_detail_status",
      ellipsis: true,
      render: (value, record) => {
        if (
          record.hasOwnProperty("is_deposit") &&
          record.is_deposit &&
          value === "ready"
        ) {
          return "무통장 입금대기";
        } else {
          return status.orderStatusChange(value);
        }
      },
    },
    {
      title: "구매자명",
      width: 90,
      dataIndex: "created_by_name",
      key: "created_by_name",
      ellipsis: true,
    },
    {
      title: "수량",
      width: 90,
      dataIndex: "quantity",
      key: "quantity",
      ellipsis: true,
    },
    {
      title: "주문번호",
      width: 90,
      dataIndex: "order_id",
      key: "order_id",
      fixed: mediaResult ? "" : "left",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value, record) => {
        return (
          <span
            className="recommend-inquiry-list-title"
            onClick={() => {
              setOrderDetail(record);
              setIsOrderModalOpen(true);
            }}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "주문일시",
      width: 160,
      dataIndex: "created_at",
      key: "created_at",
      ellipsis: true,
      // // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "결제일",
      width: 160,
      dataIndex: "payment_created_at",
      key: "payment_created_at",
      ellipsis: true,
      // // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "상품명",
      // width: 200,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
    },
    {
      title: "옵션명",
      // width: 200,
      dataIndex: "option_title",
      key: "option_title",
      ellipsis: true,
    },
    {
      title: "상품번호",
      // width: 200,
      dataIndex: "product_id",
      key: "product_id",
      ellipsis: true,
    },
    {
      title: "클레임상태",
      width: 150,
      dataIndex: "",
      key: "",
    },
    {
      title: "연락처",
      // width: 90,
      dataIndex: "phone",
      key: "phone",
      ellipsis: true,
    },
    {
      title: "주소",
      // width: 90,
      dataIndex: "address",
      key: "address",
      ellipsis: true,
    },
    {
      title: "상세주소",
      // width: 90,
      dataIndex: "address_detail",
      key: "address_detail",
      ellipsis: true,
    },
  ];

  useEffect(() => {
    if (searchText && searchText !== " " && searchText === "ready") {
      setSearchOptions({ ...searchOptions, searchStatus: "ready" });
      getUserOrderList("custom", searchText);
    }
  }, [searchText]);

  useEffect(() => {
    setOrderList(totalOrderList.slice(offset, offset + pageSize));
  }, [offset, pageSize]);

  useEffect(() => {
    handleChangePagination(currentPageNumber);
  }, [pageSize]);

  useEffect(() => {
    if (searchText && searchText !== " " && searchText === "ready") {
      getUserOrderList("custom", searchText);
    } else {
      getUserOrderList();
    }
  }, [orderType, orderBy]);

  const getUserOrderList = async (type = "", searchStatus) => {
    setIsLoading(true);
    try {
      let res;
      if (type === "initial") {
        res = await salesManageApi.searchOrderDetailList(
          0,
          10,
          "orderTotalSearch",
          searchDateItems[0].searchType,
          moment().subtract(7, "days").startOf("day").format("YYYYMMDDHHmm"),
          moment().endOf("day").format("YYYYMMDDHHmm"),
          orderStatusItems[0].value,
          "",
          "",
          0,
          "",
          "",
          "payment_created_at",
          "desc",
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      } else if (type === "search") {
        res = await salesManageApi.searchOrderDetailList(
          0,
          10,
          "orderTotalSearch",
          searchOptions.searchType,
          searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm"),
          searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm"),
          searchOptions.searchStatus,
          searchOptions.searchOrderId,
          searchOptions.searchProductName,
          searchOptions.funnel,
          searchOptions.name,
          searchOptions.phone.includes("-")
            ? searchOptions.phone.replaceAll("-", "")
            : searchOptions.phone,
          orderType,
          orderBy,
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      } else if (type === "custom") {
        res = await salesManageApi.searchOrderDetailList(
          0,
          10,
          "orderTotalSearch",
          searchOptions.searchType,
          searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm"),
          searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm"),
          searchStatus,
          searchOptions.searchOrderId,
          searchOptions.searchProductName,
          searchOptions.funnel,
          searchOptions.name,
          searchOptions.phone.includes("-")
            ? searchOptions.phone.replaceAll("-", "")
            : searchOptions.phone,
          orderType,
          orderBy,
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      } else {
        res = await salesManageApi.searchOrderDetailList(
          offset,
          pageSize,
          "orderTotalSearch",
          searchOptions.searchType,
          searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm"),
          searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm"),
          searchOptions.searchStatus,
          searchOptions.searchOrderId,
          searchOptions.searchProductName,
          searchOptions.funnel,
          searchOptions.name,
          searchOptions.phone.includes("-")
            ? searchOptions.phone.replaceAll("-", "")
            : searchOptions.phone,
          orderType,
          orderBy,
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      }
      if (res.code === 200) {
        setTotalOrderList(res.result.userOrderDetailDTOList);
        if (type === "initial" || type === "search") {
          setOrderList(res.result.userOrderDetailDTOList.slice(0, 10));
        } else {
          setOrderList(
            res.result.userOrderDetailDTOList.slice(offset, offset + pageSize),
          );
        }
        if (res.result?.length !== 0) {
          setTotalSize(res.result.totalCnt);
        } else {
          setTotalSize(0);
        }
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getUserOrderList read error", error);
    }
  };

  /**
   * 입금 완료
   */
  const handleDepositComplete = async () => {
    if (
      window.confirm(
        "해당 주문들에 대한 결제 금액이 정상적으로 입금되었는지 다시 한번 확인해주세요.",
      )
    ) {
      setIsLoading(true);
      try {
        const orderIdSet = new Set(selectedRow.map((row) => row.order_id));
        const param = {
          orderIdList: [...orderIdSet],
          created_by: user.id === 724 ? 1 : user.id,
        };
        const res = await salesManageApi.orderStatusEditForDeposit(param);
        if (res.code === 200) {
          setIsLoading(false);
          alert("해당 주문들에 대한 입금 완료 처리를 성공적으로 반영했습니다.");
          if (searchText && searchText !== " " && searchText === "ready") {
            getUserOrderList("custom", searchText);
            setOffset(0);
            setPageSize(10);
            setSelectedRowKey([]);
            setSelectedRow([]);
          } else {
            handleInitialBtnClick();
          }
        } else if (res.code === 999) {
          throw res.msg;
        } else {
          throw "해당 주문들에 대한 입금 완료 처리에 실패하였습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.";
        }
      } catch (error) {
        setIsLoading(false);
        setError(error);
        console.log("handleDepositComplete edit error", error);
        alert(error);
      }
    }
  };

  /**
   * 무통장 입금 주문건 취소 처리 ok handler
   */
  const handleDepositCancelModalOk = async () => {
    setIsLoading(true);
    try {
      let cancelInfoList = [];
      let cancelAlertList = [];
      let cancelCouponParamList = [];
      let cancelUsePointParamList = [];
      const orderIdSet = new Set(selectedRow.map((row) => row.order_id));
      for (const orderId of [...orderIdSet]) {
        const orderDetailList = selectedRow.filter(
          (row) => row.order_id === orderId,
        );
        let cancelCouponIdList = [];
        for (const orderDetail of orderDetailList) {
          if (
            orderDetail.coupon_id !== null &&
            orderDetail.coupon_id !== "ADMIN"
          ) {
            cancelCouponIdList.push(orderDetail.coupon_id);
          }
        }
        const cancelInfo = {
          totalOrder: {
            id: orderId,
            created_by: orderDetailList[0].created_by,
            order_status: "cancel_complete",
          },
          orderDetailList: orderDetailList,
          cancel_reason: editCancelReason.cancel_reason,
          cancel_reason_detail:
            editCancelReason.hasOwnProperty("cancel_reason_detail") &&
            editCancelReason.cancel_reason_detail !== null &&
            editCancelReason.cancel_reason_detail !== ""
              ? editCancelReason.cancel_reason_detail
              : "",
          cancel_target: "admin",
          refund_holder: null,
          refund_bank: null,
          refund_account: null,
          created_by: user.id === 724 ? 1 : user.id,
        };
        cancelInfoList.push(cancelInfo);
        // 취소 안내 알림톡 내용
        const cancelAlert = {
          order_id: orderId,
          name:
            orderDetailList?.length > 1
              ? `${orderDetailList[0].product_brand_name} ${
                  orderDetailList[0].product_brand_name
                } 외 ${orderDetailList?.length - 1}건`
              : `${orderDetailList[0].product_brand_name} ${orderDetailList[0].product_brand_name}`,
          cancel_reason: `[${editCancelReason.cancel_reason}] ${
            editCancelReason.hasOwnProperty("cancel_reason_detail") &&
            editCancelReason.cancel_reason_detail !== null &&
            editCancelReason.cancel_reason_detail !== ""
              ? editCancelReason.cancel_reason_detail
              : ""
          }`,
          created_by: orderDetailList[0].created_by,
        };
        cancelAlertList.push(cancelAlert);
        // 사용 쿠폰 환급
        if (cancelCouponIdList?.length !== 0) {
          const cancelCoupon = {
            couponIdList: cancelCouponIdList,
            user_coupon_is_available: true,
            user_id: orderDetailList[0].created_by,
            created_by: user.id,
          };
          cancelCouponParamList.push(cancelCoupon);
        }
        // UserOrder > 사용 포인트 환급
        if (orderDetailList[0].use_point !== null) {
          const cancelPointParam = {
            totalOrder: {
              id: orderId,
              order_status: "cancel_complete",
            },
          };
          cancelUsePointParamList.push(cancelPointParam);
        }
      }
      for (const cancelInfo of cancelInfoList) {
        const cancelRes = await salesManageApi.orderEdit(cancelInfo);
        if (cancelRes.code !== 200) {
          setTimeout(() => {
            handelDepositCancelModalCancel();
          }, 1000);
          if (cancelRes.code === 999) {
            throw cancelRes.msg;
          } else {
            throw `해당 주문건에 대한 정보를 저장하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
          }
        }
      }
      for (const cancelCouponParam of cancelCouponParamList) {
        const cancelCouponRes = await promotionApi.userCouponChangeStatus(
          cancelCouponParam,
        );
        if (cancelCouponRes.code !== 200) {
          setTimeout(() => {
            handelDepositCancelModalCancel();
          }, 1000);
          if (cancelCouponRes.code === 999) {
            throw cancelCouponRes.msg;
          } else {
            throw `선택한 주문건들 중 사용한 쿠폰 정보를 수정하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
          }
        }
      }
      for (const cancelPointParam of cancelUsePointParamList) {
        const cancelPointRes = await salesManageApi.purchasePointCancel(
          cancelPointParam,
        );
        if (cancelPointRes.code !== 200) {
          setTimeout(() => {
            handelDepositCancelModalCancel();
          }, 1000);
          if (cancelPointRes.code === 999) {
            throw cancelPointRes.msg;
          } else {
            throw `주문번호: ${cancelPointParam.totalOrder.id} 인 주문건에서 사용한 포인트를 환급하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
          }
        }
      }
      const kakaoAlertParam = {
        orderDetailList: cancelAlertList,
      };
      const kakaoRes = await pushApi.kakaoForDepositCancel(kakaoAlertParam);
      if (kakaoRes.code !== 200) {
        setTimeout(() => {
          handelDepositCancelModalCancel();
        }, 1000);
        throw `해당 주문건들에 대한 알림톡을 전송하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
      }
      setIsLoading(false);
      alert("해당 주문건들이 성공적으로 취소되었습니다.");
      setTimeout(() => {
        handelDepositCancelModalCancel();
      }, 1000);
      if (searchText && searchText !== " " && searchText === "ready") {
        getUserOrderList("custom", searchText);
      } else {
        getUserOrderList();
      }
    } catch (e) {
      setIsLoading(false);
      setError(error);
      console.log("handleDepositCancelModalOk error", e);
      alert(e);
    }
  };

  /**
   * excel download
   */
  const handleExcelDownloadClick = () => {
    try {
      let excelData;
      if (selectedRow?.length !== 0) {
        excelData = selectedRow.map((row) => {
          return {
            order_id: row.order_id,
            order_detail_id: `dy${row.order_detail_id}`,
            payment_created_at: moment(row.payment_created_at).format(
              "YYYY.MM.DD HH:mm",
            ),
            order_detail_status:
              status.matchingOrderStatus[row.order_detail_status],
            product_id: row.product_id,
            product_name: row.product_name,
            option_id: row.option_id,
            option_title: row.option_title,
            quantity: row.quantity,
            total_price: row.total_price,
            price: row.price,
            coupon_discount_price: row.coupon_discount_price,
            created_by_name: row.created_by_name,
            use_point: row.use_point ? "Y" : "N",
            name: row.name,
            phone: row.phone,
            address: row.address
              ? row.address +
                (row.address_detail ? `, ${row.address_detail}` : "")
              : "",
            address_request:
              row.address_request === "배송 시 요청사항을 선택해주세요."
                ? ""
                : row.address_request,
            delivery_company: status.matchingDeliveryCompany[
              row.delivery_company
            ]
              ? status.matchingDeliveryCompany[row.delivery_company]
              : row.delivery_company,
            tracking_number: row.tracking_number,
            ship_date: row.ship_date
              ? moment(row.ship_date).format("YYYY.MM.DD")
              : row.ship_date,
          };
        });
      } else if (totalOrderList?.length !== 0) {
        excelData = totalOrderList.map((row) => {
          return {
            order_id: row.order_id,
            order_detail_id: `dy${row.order_detail_id}`,
            payment_created_at: moment(row.payment_created_at).format(
              "YYYY.MM.DD HH:mm",
            ),
            order_detail_status:
              status.matchingOrderStatus[row.order_detail_status],
            product_id: row.product_id,
            product_name: row.product_name,
            option_id: row.option_id,
            option_title: row.option_title,
            quantity: row.quantity,
            total_price: row.total_price,
            price: row.price,
            coupon_discount_price: row.coupon_discount_price,
            created_by_name: row.created_by_name,
            use_point: row.use_point ? "Y" : "N",
            name: row.name,
            phone: row.phone,
            address: row.address
              ? row.address +
                (row.address_detail ? `, ${row.address_detail}` : "")
              : "",
            address_request:
              row.address_request === "배송 시 요청사항을 선택해주세요."
                ? ""
                : row.address_request,
            delivery_company: status.matchingDeliveryCompany[
              row.delivery_company
            ]
              ? status.matchingDeliveryCompany[row.delivery_company]
              : row.delivery_company,
            tracking_number: row.tracking_number,
            ship_date: row.ship_date
              ? moment(row.ship_date).format("YYYY.MM.DD")
              : row.ship_date,
          };
        });
      } else {
        alert(
          "다운받으려는 데이터가 없습니다. 조회 후 다시 시도해주시길 바랍니다.",
        );
        throw "no data";
      }
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);
      Object.keys(excelData[0]).forEach((key, idx) => {
        const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 });
        ws[cellAdd].v = status.matchingKey[key];
      });
      XLSX.utils.book_append_sheet(wb, ws, "주문통합검색");
      XLSX.writeFile(wb, `${moment().format("YYYYMMDD")}_주문통합검색.xlsx`);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("handleExcelDownloadClick edit error", error);
    }
  };

  /**
   * 선택 주문 SMS 전송
   */
  const sendSms = () => {
    if (
      window.confirm("선택한 주문들의 구매자분들에게 SMS를 전송하시겠습니까?")
    ) {
      let orderSmsList = [];
      const orderIdSet = new Set(selectedRow.map((row) => row.order_id));
      for (const orderId of [...orderIdSet]) {
        const orderDetailList = selectedRow.filter(
          (row) => row.order_id === orderId,
        );
        const findIdx = orderSmsList.findIndex(
          (order) => order.phone === orderDetailList[0].phone,
        );
        if (findIdx === -1) {
          const order = {
            order_id: orderId,
            name: orderDetailList[0].name,
            phone: orderDetailList[0].phone,
          };
          orderSmsList.push(order);
        }
      }
      setSelectOrderList(orderSmsList);
      history.push("/memberManage/send/sms");
    }
  };

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    switch (value) {
      case "today":
        setSearchOptions({
          ...searchOptions,
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day"),
        });
        break;
      case "1week":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(7, "days")
              .startOf("day"),
          });
        }
        break;
      case "1month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "months")
              .startOf("day"),
          });
        }
        break;
      case "3month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(3, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(3, "months")
              .startOf("day"),
          });
        }
        break;
      case "6month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(6, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(6, "months")
              .startOf("day"),
          });
        }
        break;
    }
  };

  /**
   * 검색
   */
  const handleSearch = () => {
    setOffset(0);
    setCurrentPageNumber(1);
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert("조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.");
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          "조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.",
        );
      } else {
        setIsSearchText("");
        getUserOrderList("search");
      }
    }
    // if (searchOptions.searchStatus === "total"
    //     || searchOptions.searchStatus === "ready"
    //     || searchOptions.searchStatus === " ") {
    //     setCancelButtonShow(true);
    // } else {
    //     setCancelButtonShow(false);
    // }
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      searchType: searchDateItems[0].searchType,
      searchStatus: orderStatusItems[0].value,
      searchOrderId: "",
      searchProductName: "",
      funnel: 0,
      name: "",
      phone: "",
      startDate: moment().subtract(7, "days").startOf("day"),
      endDate: moment().endOf("day"),
    });
    setDateType(dateTypeItems[1].value);
    setOffset(0);
    setPageSize(10);
    setSelectedRowKey([]);
    setSelectedRow([]);
    setIsSearchText("");
    getUserOrderList("initial");
  };

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("payment_created_at");
        setOrderBy("desc");
      }
    }
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(currOffset);
  };

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset((current - 1) * pageSize);
  };

  /**
   * 주문 상세 Modal cancel handler
   */
  const handleOrderDetailModalCancel = () => {
    setIsOrderModalOpen(false);
    setOrderDetail({});
  };

  /**
   * 무통장 입금 주문건 취소 처리 cancel handler
   */
  const handelDepositCancelModalCancel = async () => {
    setIsDepositCancelModalOpen(false);
    // setReadyCancelShow(false);
    setSelectedRow([]);
    setSelectedRowKey([]);
    setEditCancelReason({
      cancel_reason: null,
      refund_bank: null,
    });
  };

  /**
   * 입금완료 disabled
   */
  const disabledDepositComplete = () => {
    if (selectedRow?.length === 0) {
      return true;
    } else {
      let validList = [];
      for (const row of selectedRow) {
        // if (row.hasOwnProperty("is_deposit") && row.is_deposit && row.order_detail_status === "ready") {
        if (row.order_detail_status === "ready") {
          validList.push(true);
        } else {
          validList.push(false);
        }
      }
      return !validList.every((result) => result);
    }
  };

  return (
    <>
      <ContentHeaderComponent title="주문통합검색" />
      <div className="product-register-wrap">
        {/*주문검색*/}
        <div className="product-search-box-wrap">
          <Form.Item
            label="조회기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
            id={`body-mobile`}
          >
            <Select
              value={searchOptions.searchType}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchType: value })
              }
              style={{ width: 120, textAlign: "left" }}
            >
              {searchDateItems.map((item, idx) => (
                <Option
                  key={`order_date_search_${idx}`}
                  value={item.searchType}
                >
                  {item.searchText}
                </Option>
              ))}
            </Select>
            <Row align={"middle"} style={{ marginTop: 10, gap: 5 }}>
              <Radio.Group
                className={`options-list`}
                options={dateTypeItems}
                onChange={handleDateTypeChange}
                value={dateType}
                optionType="button"
              />
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.startDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, startDate: value });
                }}
              />
              ~
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.endDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, endDate: value });
                }}
              />
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="주문상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchStatus}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchStatus: value })
              }
              style={{ width: 250, textAlign: "left" }}
            >
              {orderStatusItems.map((item, idx) => (
                <Option key={`order_status_search_${idx}`} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="유입경로"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              options={funnelStatusItems}
              onChange={(e) =>
                setSearchOptions({ ...searchOptions, funnel: e.target.value })
              }
              value={searchOptions.funnel}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle">
              <Col sm={5} md={2}>
                <div className="content-search-wrap">주문번호</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="searchOrderId"
                  value={searchOptions.searchOrderId}
                  onChange={(e) => {
                    const reg = /^[0-9]*$/;
                    if (reg.test(e.target.value) || e.target.value === "") {
                      setSearchOptions({
                        ...searchOptions,
                        [e.target.name]: e.target.value,
                      });
                    }
                  }}
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">상품명</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="searchProductName"
                  value={searchOptions.searchProductName}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
            <Row align="middle" style={{ marginTop: 10 }}>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">이름</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="name"
                  value={searchOptions.name}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">연락처</div>
              </Col>
              <Col>
                <Input
                  name="phone"
                  value={searchOptions.phone}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Row className="product-search-button-wrap" justify="center">
            <Button
              className="product-search-button search"
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className="product-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*주문목록*/}
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          {mediaResult && (
            <button
              className={`order-column-change-button`}
              onClick={() => {
                setMobileColumn(!mobileColumn);
              }}
            >
              {mobileColumn ? "기존으로 전환" : "이름/가격 우선으로 전환"}
            </button>
          )}
          <div>
            <span className="product-register-box-title">
              주문목록 (총{" "}
              <span
                className="product-register-box-subtitle"
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className="product-list-subtitle">
              {orderPair[orderType]}
            </span>
          </div>
          <div>
            <Button
              className="order-excel-download-btn"
              icon={
                <img
                  style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/microsoftexcel.png`}
                />
              }
              onClick={handleExcelDownloadClick}
            >
              엑셀다운
            </Button>
            <Button
              disabled={disabledDepositComplete()}
              onClick={sendSms}
              style={{ marginLeft: 10 }}
            >
              무통장 주문 SMS
            </Button>
            <Button
              disabled={disabledDepositComplete()}
              onClick={() => setIsDepositCancelModalOpen(true)}
              style={{ marginLeft: 10 }}
            >
              무통장 주문 취소
            </Button>
            {/*{cancelButtonShow && (*/}
            {/*    <Button disabled={!disabledDepositComplete()} onClick={() => setReadyCancelShow(true)}*/}
            {/*            style={{marginLeft: 10}}>입금대기취소</Button>*/}
            {/*)}*/}
            <Button
              disabled={disabledDepositComplete()}
              onClick={handleDepositComplete}
              style={{ marginLeft: 10 }}
            >
              입금완료
            </Button>
          </div>
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{ padding: "20px 25px 40px", height: "fit-content" }}
        >
          <Table
            rowSelection={rowSelection}
            columns={mobileColumn ? columnsChange : columns}
            dataSource={orderList}
            loading={isLoading}
            tableLayout={"auto"}
            bordered
            size="middle"
            rowKey="order_detail_id"
            rowClassName="coupon-table-row"
            // scroll={{x: 'calc(700px + 50%)'}}
            scroll={{ x: "max-content" }}
            onChange={tableOnChange}
            pagination={false}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              showSizeChanger
              pageSize={pageSize}
              onShowSizeChange={pageSizeChange}
              total={totalSize}
              onChange={handleChangePagination}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>
        <div
          className="product-register-border-box"
          style={{
            borderTop: 0,
            backgroundColor: "#f8f9fd",
            height: "fit-content",
            padding: "15px 25px",
          }}
        >
          <Form.Item
            className="order-bottom-form-item center-label"
            label="주문관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            발주/발송처리
            <img
              className="order-bottom-form-item-arrow-icon"
              src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/Icon.png`}
            />
            {/*발송지연처리<img className="order-bottom-form-item-arrow-icon"*/}
            {/*           src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/Icon.png`}/>*/}
            배송지 정보 수정
            {/*<img className="order-bottom-form-item-arrow-icon"*/}
            {/*              src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/Icon.png`}/>*/}
            {/*미결제 확인*/}
          </Form.Item>
          <Divider className="product-register-form-input-divider order-bottom-divider-margin" />
          <Form.Item
            className="order-bottom-form-item center-label"
            label="취소관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            판매자 직접취소 처리
            <img
              className="order-bottom-form-item-arrow-icon"
              src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/Icon.png`}
            />
            취소 승인처리
            <img
              className="order-bottom-form-item-arrow-icon"
              src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/Icon.png`}
            />
            구매확정 후 취소처리
          </Form.Item>
          <Divider className="product-register-form-input-divider order-bottom-divider-margin" />
          <Form.Item
            className="order-bottom-form-item center-label"
            label="반품교환관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            반품 및 교환접수
            <img
              className="order-bottom-form-item-arrow-icon"
              src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/Icon.png`}
            />
            반품접수 후 처리
            {/*<img className="order-bottom-form-item-arrow-icon"*/}
            {/*              src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/Icon.png`}/>*/}
            {/*교환접수 후 처리*/}
          </Form.Item>
        </div>
      </div>

      {/*주문 상세 페이지*/}
      {isOrderModalOpen && (
        <Modal
          title="상품주문정보 조회"
          wrapClassName="order-detail-modal-wrap"
          visible={isOrderModalOpen}
          centered={true}
          onCancel={handleOrderDetailModalCancel}
          footer={null}
          width="70%"
        >
          <OrderDetailComponent
            orderDetail={orderDetail}
            handleOrderDetailModalCancel={handleOrderDetailModalCancel}
            getUserOrderList={getUserOrderList}
          />
        </Modal>
      )}

      {/*무통장 주문 취소 처리*/}
      {isDepositCancelModalOpen && (
        <Modal
          title="무통장 주문 취소"
          visible={isDepositCancelModalOpen}
          onCancel={handelDepositCancelModalCancel}
          onOk={handleDepositCancelModalOk}
          cancelText={<span>닫기</span>}
          okText={<span>주문 취소</span>}
          confirmLoading={isLoading}
          width={"50%"}
        >
          <Form.Item
            label="주문 취소 사유"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            required
          >
            <Select
              placeholder="선택"
              value={editCancelReason.cancel_reason}
              onChange={(value) =>
                setEditCancelReason({
                  ...editCancelReason,
                  cancel_reason: value,
                })
              }
              style={{ width: 250, textAlign: "left" }}
            >
              {cancelReasonItems.map((item, idx) => (
                <Option key={`order_cancel_reason_${idx}`} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="구매자에게 전하실 말씀"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Input.TextArea
              className="order-modal-address-request-wrap"
              name="cancel_reason_detail"
              value={editCancelReason.cancel_reason_detail}
              onChange={(e) =>
                setEditCancelReason({
                  ...editCancelReason,
                  [e.target.name]: e.target.value,
                })
              }
              rows={5}
            />
          </Form.Item>
        </Modal>
      )}
      {/*{readyCancelShow && (*/}
      {/*    <Modal*/}
      {/*        title="입금 대기 주문 취소"*/}
      {/*        visible={readyCancelShow}*/}
      {/*        onCancel={handelDepositCancelModalCancel}*/}
      {/*        onOk={handleDepositCancelModalOk}*/}
      {/*        cancelText={<span>닫기</span>}*/}
      {/*        okText={<span>주문 취소</span>}*/}
      {/*        confirmLoading={isLoading}*/}
      {/*        width={"50%"}*/}
      {/*    >*/}
      {/*        <Form.Item*/}
      {/*            label="주문 취소 사유"*/}
      {/*            labelAlign="left"*/}
      {/*            colon={false}*/}
      {/*            labelCol={{span: 6}}*/}
      {/*            wrapperCol={{span: 18}}*/}
      {/*            required*/}
      {/*        >*/}
      {/*            <Select placeholder="선택" value={editCancelReason.cancel_reason}*/}
      {/*                    onChange={(value) => setEditCancelReason({...editCancelReason, cancel_reason: value})}*/}
      {/*                    style={{width: 250, textAlign: 'left'}}>*/}
      {/*                {cancelReasonItems.map((item, idx) => <Option key={`order_cancel_reason_${idx}`}*/}
      {/*                                                              value={item.value}>{item.label}</Option>)}*/}
      {/*            </Select>*/}
      {/*        </Form.Item>*/}
      {/*        <Form.Item*/}
      {/*            label="구매자에게 전하실 말씀"*/}
      {/*            labelAlign="left"*/}
      {/*            colon={false}*/}
      {/*            labelCol={{span: 6}}*/}
      {/*            wrapperCol={{span: 18}}*/}
      {/*        >*/}
      {/*            <Input.TextArea*/}
      {/*                className="order-modal-address-request-wrap"*/}
      {/*                name="cancel_reason_detail"*/}
      {/*                value={editCancelReason.cancel_reason_detail}*/}
      {/*                onChange={(e) => setEditCancelReason({*/}
      {/*                    ...editCancelReason,*/}
      {/*                    [e.target.name]: e.target.value*/}
      {/*                })}*/}
      {/*                rows={5}*/}
      {/*            />*/}
      {/*        </Form.Item>*/}
      {/*    </Modal>*/}
      {/*)}*/}
    </>
  );
};

export default SalesManageSearchComponent;
